import { commentCasePrefix } from '../constants';

/**
 * Is Include Comment Case
 */
const isIncludeCommentCase = (text: string) =>
  text.startsWith(commentCasePrefix);

export { isIncludeCommentCase };
